/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurring_MaterializeInputs */

const en_recurring_materialize = /** @type {(inputs: Recurring_MaterializeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materialize next`)
};

const he_recurring_materialize = /** @type {(inputs: Recurring_MaterializeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צור את הבא`)
};

/**
* | output |
* | --- |
* | "Materialize next" |
*
* @param {Recurring_MaterializeInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const recurring_materialize = /** @type {((inputs?: Recurring_MaterializeInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurring_MaterializeInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurring_materialize(inputs)
	return he_recurring_materialize(inputs)
});